/* eslint-disable */
import React, { Component } from 'react'
import { ScrollView, Text, KeyboardAvoidingView, View, StatusBar, Alert, Image, Dimensions } from 'react-native'
import { NavigationActions, StackActions } from 'react-navigation'
import { connect } from 'react-redux'
import AppNavigation from '../Navigation/AppNavigation'
import styles from './Styles/SwiperContainerScreenStyle'
import AuthActions from '../Redux/AuthRedux'
import SwiperActions from '../Redux/SwiperRedux'
import PostsActions from "../Redux/PostsRedux"
//import Swiper from 'react-native-swiper'
//import CameraScreen from './CameraScreen'
//import DonatePayPalComponent from '../Components/DonatePayPalComponent'
import SoundPlayer from 'react-native-sound-player'
import { NativeEventEmitter, NativeModules } from 'react-native'; // for catching camera events to lock/unlock scroll
import NotificationManager from '../Lib/NotificationManager'
import { getAvatar, objectDeepCopy } from '../Lib/utils'
import { Fonts } from '../Themes'
import I18n from "i18n-js"
import PostViewScreen from '../Containers/PostViewScreen'


const FORCE_PLAY = true

// move from render()

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

const windowAR = windowHeight/windowWidth

let singleView = true // narrow windows ... the app way
if (windowAR < 1) { // not sure what number to put here, 4/3 seems like it should still be the one window way
  singleView = false // allow wide windows on desktop
}

if (!singleView) {
  // hack for web trial
  window.mainViewWidthFraction = 0.6 // see also below 
} else {
  window.mainViewWidthFraction = 1
}

class SwiperContainerScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      changeIndex: 1,
      isScroll: true,
      camIsScroll : true, // separate control from camera to avoid making logic more complex
      shouldUpdate: true,
      priorTouchMoveX: 0,
      sentSwipeToCamera: false,
      popupYOffset : 0,
      minTime : 0,
      cameraHot: false, // hot = cam viewfinder preview screen (live video) enabled
      swiperWidth : 375, // put a reasonable value for 6 sized phones until onLayout is fired
      lockScroll : false,
      needsLoginTimeStamp: null,
    }

    // get events from camera like lock main side swipe or not
    const { CameraEventManager } = NativeModules;
    const eventEmitter = new NativeEventEmitter(CameraEventManager);
    // this is working, whew (at least it is getting called from RNCameraManager.m)
    const onEventFromCam = (event) => {
          console.log("SwiperContainerScreen onEventFromCam event = " + JSON.stringify(event))

          const flag = event.scrollEnabled === "1" ? true : false
          this.setState({ camIsScroll: flag })
    }
    const subscription = eventEmitter.addListener('lockMainAppScroll', onEventFromCam.bind(this));

		this.currentSong = null
		this.preloadSong = null
    // this.currentSongState = 'stopped'
    this.stopMusic = this.stopMusic.bind(this)
    this.playMusic = this.playMusic.bind(this)
    this.muteMusic = this.muteMusic.bind(this)
    this.restartMusic = this.restartMusic.bind(this)
    this.clearMusicRepeat = this.clearMusicRepeat.bind(this)
    this.startMusicRepeat = this.startMusicRepeat.bind(this)
    this.musicTimeout = null
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this)
    this.shouldComponentUpdate = this.shouldComponentUpdate.bind(this)
  }
  // copied from post wall base
  cancelPost = () => { // now what?
    console.log("cancel post pressed in swiper container screen")
    // this should tell objective C camera to cancel video rendering which
    // is happening on background queues
    NotificationManager.postNotification("PostWallBase_cancelPost")
    // it make take a moment for the background process to quit, so do this later
    
    let zprog = function() {
      if (this.props.createStandardPostProgress) this.props.createStandardPostProgress(0.0) // set progress bar back back to 0 in case we cancelled a vid render
    }
    setTimeout(zprog.bind(this), 2000)
 }
  // by default in current react, this fires twice, once at scroll start and once at scroll end
  // see scrollEventThrottle in ScrollView doc (which Swiper uses or is derived from)
  _onScroll = (e) => {
    //console.log("_onScroll in swiper arg = " + Object.keys(e))
    //console.log("_onScroll in swiper offset = " + JSON.stringify(e.nativeEvent.contentOffset))
    // to do, figure exact width per each device use onLayout response ?
    if (e.nativeEvent.contentOffset.x < this.state.swiperWidth) this.setState( {cameraHot : true} )
    else this.setState( {cameraHot : false} )
  }
  _onTouchEnd = (e) => {
    if (this.props.fromScreen == 'editPost') return // if from edit post, this is a "going back to cam" operation, dont send events from swiper
    // only pass along event if in camera
    if (this.props.swiperIndex == 0) {
      this.state.sentSwipeToCamera = false // now we can re-enable
      // maybe can send a touch up to camera in case somehow the swiper hijacked the events and we cant get touch up anymore in cam
      this.props.sendTouchUpToCam({ touchUpToCam: true })
      this.props.sendDragRightOnCam({ dragRightOnCam: 0 })
  }
  }
  _onTouchStart = (e) => {
    //console.log('touchstart from swiper')
    if (this.props.fromScreen == 'editPost') return // if from edit post, this is a "going back to cam" operation, dont send events from swiper
    if (this.props.swiperIndex == 0) {
    // reset so a tap doesnt show a large move
      this.state.priorTouchMoveX =  e.nativeEvent.locationX
      this.props.sendTouchUpToCam({ touchUpToCam: false }) // clear the end flag on next start, clear the drag right delta
      this.props.sendDragRightOnCam({ dragRightOnCam: 0 })
    }
  }
  _onTouchMove = (e) => {
     if (this.props.fromScreen == 'editPost') return // if from edit post, this is a "going back to cam" operation, dont send events from swiper
     if (this.props.swiperIndex == 0) {
     //console.log("_onTouchMove in swiper arg = e.nativeEvent.locationX " + Object.keys(e.nativeEvent.locationX))
       var x = e.nativeEvent.locationX
       var delx = x - this.state.priorTouchMoveX
       this.state.priorTouchMoveX = x
       // if on camera side of app & long enough swipe & we havent sent a swipe yet in this move sequence...
       // add allowable negative drag right = drag left to allow dismiss of camera edit toolbar by swiping left
       // to avoid having to put the whole series of changes in to pass a drag left thru the react / ios layers
       // temp remove left drag delx < -20, not fully handled in camera
       if (this.props.swiperIndex == 0 && (delx > 20 || delx < -20) && !this.state.sentSwipeToCamera) {
         this.props.sendDragRightOnCam({ dragRightOnCam: delx })
         this.state.sentSwipeToCamera = true // dont allow another swipe until touch up
         console.log("move right on swiper container screen")
       }
       else if (x < 0) {
        //console.log("move left on swiper container screen")
       }
     }
  }
  _onIndexChanged = (index) => {

    if (this.state.indexChange !== index) {
      this.setState({
        indexChange: index,
        cameraHot : (index === 0)
      }, ( ) => {
        // stringify is called _inside redux_ (serialization) so it must be unwrapped first, or simply false
        let ktagCallerInfo = this.props.ktagCallerInfo? JSON.parse(this.props.ktagCallerInfo): false
        this.props.changeIndex({ indexChange : index, ktagCallerInfo : ktagCallerInfo
                               , fromScreen : this.props.fromScreen?  this.props.fromScreen: ''
                               })
      })
    }
    if (index == 0) {
      this.setState({
        isScroll: true
      })
    }

  }
  _changeIndex = (index) => {

    console.log("_changeIndex in swiper container screen index = " + index + " fromScreen " + this.props.fromScreen)

    if (index == 0) {
      if (!this.state.camIsScroll && this.props.fromScreen !== 'editPost') {

        // do the way post wall base was doing it, but do it here instead of in post wall base

        Alert.alert(
          '',
          'From swiper container screen:  Hey, please wait for your last post to finish processing before you get back into the camera.  Thanks!',
          [
            {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
            {text: I18n.t("editpost.cancel"),  onPress: () => this.cancelPost()}
          ],
          { cancelable: false }
     )

     /* old way 
       Alert.alert(
            '',
            'Hey, please wait for your last post to finish processing before you get back into the camera.  Thanks!',
            [
              {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
            ],
            { cancelable: true }
       )
      */
       return
      }
      // fix case:  after going Back to cam from tagging, side swiper should be locked
      if (this.props.fromScreen === 'editPost') this.state.camIsScroll = false
      this.swiper.scrollBy(-1)
    } else {
      // scroll back to app, make sure cam lock is off in this case, since we are no longer in camera
      // dont need to force re-render, so just set it
      this.state.camIsScroll = true
      this.swiper.scrollBy(1)
    }
  }

  componentWillUnmount() {
    this.clearMusicRepeat()
  }

  componentDidMount() {
    StatusBar.setHidden(false)
  }

  clearMusicRepeat = () => {
    if (this.musicRepeat) {
      clearTimeout(this.musicRepeat)
      this.musicRepeat = null
    }
  }

  startMusicRepeat = () => {
    this.clearMusicRepeat()
    this.musicRepeat = setTimeout(() => {
      this.restartMusic()
    }, 30000)
  }

  restartMusic = () => {
    // this.playMusic(this.currentSong, FORCE_PLAY)
    try {
      SoundPlayer.seek(0)
      SoundPlayer.play()
      this.startMusicRepeat()
    }
    catch (e) {
      console.tron.log(`restartMusic, could not seek`, e)
      this.stopMusic()
    }
  }

  stopMusic = () => {
    console.tron.log(`stopMusic`)
    try {
      this.clearMusicRepeat()
      SoundPlayer.stop()
    }
    catch (e) {
      console.tron.log(`stopMusic, could not SoundPlayer.stop`, e)
    }
  }

  preloadMusic = (songDetails) => {
    try {
			const songId = songDetails ? songDetails.id : null
			const oldPreloadSongId = this.preloadSong ? this.preloadSong.id : null
			if (songId && songId != oldPreloadSongId) {
				console.tron.log(`preloadMusic songId: ${songId}`)
				this.preloadSong = songDetails
				SoundPlayer.loadUrl(songDetails.musicPreviewUrl)
			}
    }
    catch (e) {
      console.tron.log(`preloadMusic, could not SoundPlayer.preloadMusic`, e)
    }
  }

  playMusic = (songDetails, forcePlay = false) => {
    // console.tron.log(`playMusic songDetails: ` + JSON.stringify(songDetails))
    if (true) { // songDetails) {
      try {
        const songId = songDetails ? songDetails.id : null
        const currentSongId = this.currentSong ? this.currentSong.id : null
        if (forcePlay || currentSongId != songId) {
          if (currentSongId != songId)
            this.currentSong = objectDeepCopy(songDetails)
          if (!this.songMuted && songId) {
            SoundPlayer.playUrl(this.currentSong.musicPreviewUrl)
            this.startMusicRepeat()
          }
          else
            this.stopMusic()
          // TODO - 30 second timer to repeat...
        }
      }
      catch (e) {
        console.tron.log(`playMusic, could not SoundPlayer.playUrl`, e)
        this.stopMusic()
      }
    }
    else
      this.stopMusic()
  }

  muteMusic = (mute) => {
    console.tron.log(`muteMusic: ` + JSON.stringify(mute))
    this.songMuted = mute
    if (mute)
      this.stopMusic()
    else
      this.playMusic(this.currentSong, FORCE_PLAY)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.music != this.props.music) {
      // console.tron.log(`swiperContainer componentWillReceiveProps music changed`) // : ` + JSON.stringify(nextProps.music))
      const thisMusic = this.props.music
			const nextMusic = nextProps.music
			const preloadMusic = nextProps.preloadMusic
      if (false) // typeof nextMusic.muted == 'undefined' && typeof nextMusic.songDetails == 'undefined')
        this.stopMusic()
      else {
        if (typeof nextMusic.muted != 'undefined' && thisMusic.muted != nextMusic.muted)
          this.muteMusic(nextMusic.muted)

        if (thisMusic.songDetails != nextMusic.songDetails)
						this.playMusic(nextMusic.songDetails)
						
				if (preloadMusic)
					this.preloadMusic(preloadMusic.songDetails)
/*
        if (typeof nextMusic.songDetails != 'undefined' && thisMusic.songDetails != nextMusic.songDetails) {
          if (nextMusic.songDetails == null)
            this.stopMusic()
          else
            this.playMusic(nextMusic.songDetails)
        }
*/
      }
    }

    if (this.props.swiperIndex !== nextProps.swiperIndex && this.state.indexChange !== nextProps.swiperIndex) {
      this.setState({
        changeIndex: nextProps.swiperIndex,
      }, () => {
        this._changeIndex(this.state.changeIndex)
      })
    }
  }

  objectsEqualSkipMusic = (obj1, obj2) => {
    return Object.keys(obj1)
      .concat(Object.keys(obj2))
      .every(key => {
        return key == 'music' || obj1[key] === obj2[key];
      })
  }

  shouldComponentUpdate(nextProps, nextState) {

    console.info("forceRefreshIndex = " + nextProps.forceRefreshIndex)

    // return true // navigation not working!!
    // return true // should skip if only music state changes, as it is not a visual change, ie: props or state changed

/*
    if (this.props.music.muted != nextProps.music.muted)
      return false
    const thisSongDetailsId = this.props.music.songDetails ? this.props.music.songDetails.id : null
    const nextSongDetailsId = nextProps.music.songDetails ? nextProps.music.songDetails.id : null
    if (thisSongDetailsId != nextSongDetailsId)
      return false
*/

/*
    console.tron.log("swiper SCU props: " + JSON.stringify(this.props))
    console.tron.log("swiper SCU nextProps: " + JSON.stringify(nextProps))
    console.tron.log("swiper SCU state: " + JSON.stringify(this.state))
    console.tron.log("swiper SCU nextState: " + JSON.stringify(nextState))
    return true
*/

    try {
      // fromScreen: state.swiper.fromScreen,
      if (this.props.fromScreen != nextProps.fromScreen)
        return true
      // swiperIndex: state.swiper.indexChange,
      if (this.props.swiperIndex != nextProps.swiperIndex)
        return true
      // ktagCallerInfo: state.swiper.ktagCallerInfo,  Ignored
      // cameraLockout: state.swiper.cameraLockout,
      if (this.props.cameraLockout != nextProps.cameraLockout)
        return true
      // music: state.swiper.music, Ignored
      // order: state.websocket.order,
      if (this.props.order.OrderId != nextProps.order.OrderId)
        return true
      // coupon: state.websocket.coupon,
      if (this.props.coupon.CouponId != nextProps.coupon.CouponId)
        return true
      if (!this.objectsEqualSkipMusic(this.state, nextState))
        return true
      if (!this.objectsEqualSkipMusic(this.props, nextProps))
        return true
    }
    catch (e) {
      return true
    }
    // console.tron.log("swiper shouldComponentUpdate false")

    return false
  }


  render ( ) {
    //console.log("swiper container screen render")
    // console.tron.log(`Swiper render`)
    this.props.screenProps.setSwiperState = this.setState.bind(this)
    const { navigation, navigation : { state : { routes } }, screenProps, swiperIndex, cameraLockout } = this.props
    let route = (routes && routes.length > 0) ? routes[routes.length-1].routeName : 'undefinedRoute'
    let currentScreen = route //routes[0].routeName
      , enabledSwiperScreens = [ 'home', 'profile' ]
      , enabledSwiper = !cameraLockout && enabledSwiperScreens.indexOf(currentScreen) !== -1

    //console.log("swiper container screen render loc 2")
    if (this.props.needsLoginTimeStamp != this.state.needsLoginTimeStamp) {
      console.tron.display({name: `SwiperContainer`, preview :`render needsLoginTimeStamp changed`, value: {props: this.props.needsLoginTimeStamp, state: this.state.needsLoginTimeStamp}})
      this.setState({ needsLoginTimeStamp: this.props.needsLoginTimeStamp })
      // TODO - check and see if we are already in Settings page
      // this.props.navigation.navigate({ routeName: 'settings', params: { doLogout : true } })
      //console.log("swiper container screen render loc 2a")
      if (this.props.needsLoginTimeStamp)
        if (routes[routes.length-1].routeName != 'settings') {
          //console.log("swiper container screen render loc 2b")
          this.props.navigation.dispatch(NavigationActions.reset({
              index: 0,
              key: null,
              actions: [NavigationActions.navigate({ routeName: 'settings', params: { doLogout : true } })]
          }))
        }
    }

    //console.log("swiper container screen render loc 3")

    const { changeIndex } = this.state
    const config = {
      velocityThreshold: 0.3,
      directionalOffsetThreshold: 80
    };
    const { order, coupon } = this.props
    // console.log("SwiperContainerScreen render order = " + JSON.stringify(order, null, 2))
    console.tron.display({name: `SwiperContainer`, preview :`render order`, value: {order}})
    const alertTime = order.Time > coupon.Time ? order.Time : coupon.Time
    const alertIsOrder = alertTime == order.Time
    const alertView = (alertTime > this.state.minTime && Date.now() - alertTime < 15000)
    const popupTouchEnd = (localorder) => {
      console.log("popup touch end, localorder = " + JSON.stringify(localorder, null, 2))
      // The touch movement wasn't even -25 pixels up, count it as a single click and not as a drag
      //if( this.offY > -25 ) {
        if (alertIsOrder) {
          console.log("tap on in app notif:  OrderId = " + localorder.OrderID)
          if (localorder.TagKind === "TheySell") // your endorsement tag was purchased by someone else
            this.props.navigation.navigate('kargoelytics', { })
          else
            this.props.navigation.navigate('kargoelyticDetail', { orderId: order.OrderId })
        }
        else if (coupon) {
          console.log("tap on in app notif, coupon")
          this.props.navigation.navigate('kargoelytics', { couponId: coupon.CouponId })
        }
      //}
      this.setState({ popupYOffset : 0, minTime : Date.now( ) })
    }

		const isOnHomeScreen = this.props.nav && this.props.nav.routes.length == 1 && this.props.nav.routes[0].routeName == 'home'
		if (this.props.auth.deepLinkTask && this.props.auth.user && isOnHomeScreen) {
			const params = Object.assign({}, this.props.auth.deepLinkTask)
			this.props.setDeepLinkTask(null)
			console.log(`SwiperContainerScreen performing DeepLinkTask to profile`)

			this.props.navigation.navigate('profilewallv2', params)
		}

    const alertContents = alertTime == order.Time ?
      (
        <View>
          <Image source={{ uri: getAvatar(order.UserId) }} resizeMode='contain' style={{ width : 40, height : 40, borderRadius : 20, marginLeft : 15, marginTop: 15, borderWidth : 1, borderColor : 'black' }} />
          <Text style={{ padding : 15, fontSize : 16, fontFamily : Fonts.style.font.regular, color : '#4f5271', flex : 1 }}>{order.Message}</Text>
        </View>
      ) :
      (
        <View>
          <Text style={{ padding : 15, fontSize : 16, fontFamily : Fonts.style.font.regular, color : '#4f5271', flex : 1 }}>{coupon.Message}</Text>
        </View>
      )

    //console.log("swiper container screen render before app nav")

    //console.log("rendering swiper, order.UserId = " + order.UserId)

    // first level view is full screen

    // 2nd screen post view trial, just send the pre-existing navigation in the other window for now
    // because we need some nav

    /* example of how postView normally is displayed

    this.props.navigation.navigate('postView', {
      post: post,
      defaultTab:  defaultTab,
      _onRefresh: this.updateForPostView,
      commentTimeStamp: commentTimeStamp, // pass along can be 0, in which case it will be ignored
      isPopup: asPopup
    })
    */

    // for postView right side, cant send them thru nav view or dont know how yet so pass in as a prop
    let altNavParams = {
      post: window.mostVisiblePost, // later pull from redux, test for now
      defaultTab:  'Comments',
      _onRefresh: window.updateForPostView ? window.updateForPostView : () => {}, // figure this out later (we need this)
      commentTimeStamp: 0, // pass along can be 0, in which case it will be ignored
      isPopup: false    
    }

    const isHome = (currentScreen == 'home')

    return (
      <View style={[styles.container, {width: '100%', height: '100%'}]}>

            <View style={[styles.container, {width: singleView ? '100%' : '60%', height: '100%'}]}>
            <AppNavigation navigation={navigation} screenProps={screenProps} />
            </View>

            {(!singleView && window.mostVisiblePost && isHome) &&
            <View style={[styles.container, {width: singleView ? '100%' : '40%', height: '100%'}, {position: 'absolute', left: '60%', top: 0}]}>
            <PostViewScreen navigation={this.props.navigation} altNavParams={altNavParams} standaloneScreen={true}/>
            </View>
            }
            {(!singleView && !window.mostVisiblePost && isHome) &&
            <View style={[styles.container, {width: singleView ? '100%' : '40%', height: '80%'}, {position: 'absolute', left: '60%', top: 0}]}>
            <Text style={{position: 'absolute', top: '30%', fontSize:26, textAlign: 'center', width: '100%'}}>Select a pic to see details and comment!</Text>
            </View>
            }


      </View>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    fromScreen: state.swiper.fromScreen,
    swiperIndex: state.swiper.indexChange,
    ktagCallerInfo: state.swiper.ktagCallerInfo,
    cameraLockout: state.swiper.cameraLockout,
		music: state.swiper.music,
		preloadMusic: state.swiper.preloadMusic,
    order: state.websocket.order,
    coupon: state.websocket.coupon,
		auth: state.auth,
		nav: state.nav,
    forceRefreshIndex: state.swiper.forceRefreshIndex
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeIndex: (index) => dispatch(SwiperActions.changeIndex(index)),
    sendDragRightOnCam: (value) => dispatch(SwiperActions.sendDragRightOnCam(value)),
    sendTouchUpToCam: (value) => dispatch(SwiperActions.sendTouchUpToCam(value)),
    createStandardPostProgress: (value) => dispatch(PostsActions.createStandardPostProgress(value)),
    setDeepLinkTask: (params) => dispatch(AuthActions.setDeepLinkTask(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SwiperContainerScreen)
